const moment = require("moment-timezone");
moment.locale("es");
moment().tz("Europe/Madrid");

export const getDiffFromNowInYears = date => {
  var now = moment();
  var dateMomented = moment(date);
  var diff = moment.duration(now.diff(dateMomented));
  return Math.trunc(diff.asYears());
};
export default moment;
